import { render, staticRenderFns } from "./ZxingEdit.vue?vue&type=template&id=31322de8&scoped=true&"
import script from "./ZxingEdit.vue?vue&type=script&lang=js&"
export * from "./ZxingEdit.vue?vue&type=script&lang=js&"
import style0 from "./ZxingEdit.vue?vue&type=style&index=0&id=31322de8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31322de8",
  null
  
)

export default component.exports